export enum Messages {
  NEW_CASE_CREATED = 'New case has been created ',
  CASE_CREATION_FAILED = 'Error: New case creation failed ',
  CASE_OPENING_FAILED = 'Error: Case opening failed ',
  CASE_UPDATED = 'Case Updated correctly ',
  CASE_UPDATED_FAILED = 'Error: Case update failed for case: ',
  CASE_DELETED = 'Case Deleted correctly ',
  CASE_PERMANENTLY_DELETED = 'Case Deleted permanently ',
  CASE_DELETION_FAILED = 'Error: Case delation failed ',
  IS_THE_SAME_PATIENT = 'Is the same patient?',
  DIFF_NOT_COMPLETE = 'Error: you have to select the value for all the variables',
  CONFIRM_CLOSE_DIFF = 'Are you sure you want to close the comparison?',
  NO_RIGHTS_FOR_HOOK = 'You don\'t have rights to perform this action',
  LOCK_IS_EXPIRING = 'Be careful, lock is expiring...',
  LOCK_IS_EXPIRED = 'Sorry, lock is expired'
}